import InfoManager from "../managers/InfoManager";
import en from "./en"
import ru from "./ru"
import uk from "./uk"
import pl from "./pl"
import de from "./de"


const dictionary = {};
dictionary.en = en;
dictionary.ru = ru;
dictionary.uk = uk;
dictionary.pl = pl;
dictionary.de = de;


export default class Localization {

    constructor(langCode) {
        this._langCode = langCode;
    }

    _langCode;

    stringFor(key) {
        return Localization.stringFor(key, this._langCode)
    }

    static stringFor(key, languageCode = InfoManager.currentLanguage) {
        if (!dictionary[languageCode]) {
            // return null
            languageCode = 'en';
        }

        return dictionary[languageCode][key] || null
    }

}